import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-write-article",
  "use": "icon-write-article-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-write-article\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 514.4m-469.5 0a469.5 469.5 0 1 0 939 0 469.5 469.5 0 1 0-939 0Z\" fill=\"#242424\" p-id=\"12112\" /><path d=\"M780.5 737.2c0 22.6-18.3 41-41 41H464.4c-22.6 0-41-18.3-41-41 0-22.6 18.3-41 41-41h275.1c22.6 0.1 41 18.4 41 41zM780.5 621.2c0 22.6-18.3 41-41 41H583.4c-22.6 0-41-18.3-41-41 0-22.6 18.3-41 41-41h156.1c22.6 0.1 41 18.4 41 41zM616.8 415.2l-267.7 301-113.2 23.4c-6.1 1.3-11.2-3.5-10.3-9.8l16.5-114.1 265.1-297.9c6.1-6.8 16-8 22.1-2.5l87.5 77.8c6.1 5.3 6.1 15.3 0 22.1zM694 328.5l-41 46.1c-3.3 3.7-9 4-12.7 0.7L544 289.8c-3.7-3.3-4-9-0.7-12.7l41.1-46.2c14.9-16.7 40.5-18.2 57.2-3.3l49.2 43.7c16.6 14.9 18.1 40.5 3.2 57.2z\" fill=\"#FFFFFF\" p-id=\"12113\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/write-article.svg
// module id = 6hw0
// module chunks = 47